import VerifiedHome from "../../components/pages/home/verifiedHome";

const VerifiedPage = () => {
	return <VerifiedHome />;
};

export default VerifiedPage;
